(() => {
  const controls = [...document.querySelectorAll('[data-mb-discount]')];
  if (!controls.length) return;
  const text = window.MERRYBLOOM_DISCOUNT_TEXT;
  const root = window.Shopify?.routes?.root || '/';
  let codes = [], busy = false;
  const names = cart => (cart.discount_codes || []).filter(code => code.applicable).map(code => code.code);
  function sync(cart) {
    codes = names(cart);
    for (const control of controls) {
      const list = control.querySelector('[data-mb-discount-codes]');
      list.replaceChildren();
      for (const code of codes) {
        const item = document.createElement('li');
        const name = document.createElement('span');
        name.textContent = code;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = '×';
        remove.setAttribute('aria-label', text.remove + ' ' + code);
        remove.disabled = busy;
        remove.addEventListener('click', () => update(codes.filter(value => value !== code), control));
        item.append(name, remove);
        list.append(item);
      }
    }
  }
  function status(message, error = false) {
    controls.forEach(control => {
      const node = control.querySelector('[data-mb-discount-status]');
      node.textContent = message;
      node.dataset.error = String(error);
    });
  }
  async function update(next, control, submitted = '') {
    if (busy) return;
    busy = true;
    controls.forEach(node => {
      node.setAttribute('aria-busy', 'true');
      node.querySelectorAll('button').forEach(button => button.disabled = true);
    });
    status(text.pending);
    try {
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: next.join(',') })
      });
      if (!response.ok) throw new Error();
      const cart = await response.json();
      const accepted = !submitted || names(cart).some(code => code.toLowerCase() === submitted.toLowerCase());
      sync(cart);
      document.dispatchEvent(new CustomEvent('lumyraze:cart-offer-applied', { detail: { cart } }));
      if (accepted) {
        control.querySelector('[data-mb-discount-input]').value = '';
        status(submitted ? text.applied : text.removed);
      } else status(text.invalid, true);
      if (accepted && document.querySelector('#LumyrazeCartForm')) {
        await new Promise(resolve => setTimeout(resolve, 600));
        window.location.reload();
      }
    } catch {
      status(text.failed, true);
    } finally {
      busy = false;
      controls.forEach(node => {
        node.removeAttribute('aria-busy');
        node.querySelectorAll('button').forEach(button => button.disabled = false);
      });
    }
  }
  for (const control of controls) {
    const input = control.querySelector('[data-mb-discount-input]');
    const apply = () => {
      const code = input.value.trim();
      if (!code) { status(text.empty, true); input.focus(); return; }
      update([...new Set([...codes, code])], control, code);
    };
    control.querySelector('[data-mb-discount-apply]').addEventListener('click', apply);
    input.addEventListener('keydown', event => {
      if (event.key === 'Enter') { event.preventDefault(); apply(); }
    });
  }
  document.addEventListener('lumyraze:cart-rendered', event => sync(event.detail.cart));
  fetch(root + 'cart.js', { credentials: 'same-origin' })
    .then(response => response.ok ? response.json() : null)
    .then(cart => { if (cart) sync(cart); }).catch(() => {});
})();
